<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="userProfile">
    <v-menu dark :close-on-content-click="false" v-if="userProfile" offset-y>
      <template v-slot:activator="{ on }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            id="navBar_userProfile"
            height="44px"
            max-width="500px"
            title="Account"
            text
            large
            v-on="on"
          >
            <v-avatar size="36px">
              <img
                v-if="userProfile.avatar"
                alt="Avatar"
                :src="userProfile.avatar"
                @error="$event.target.src = require('@assets/avatar.png')"
              />
              <v-icon v-else>mdi-account</v-icon>
            </v-avatar>
            <span
              style="
                max-width: 400px;
                text-overflow: ellipsis;
                overflow: hidden;
                font-size: 18px;
                font-weight: normal;
                text-transform: none;
              "
              class="ml-3"
              >{{ userProfile.name }}</span
            >
          </v-btn>
        </v-hover>
      </template>
      <v-list width="288px">
        <v-list-item
          @click="getStorageInfo"
          id="navBar_userProfileDialog_storageButton"
        >
          <v-list-item-icon>
             <v-icon>mdi-database</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="text-align: left"
            >Storage:
            <span class="body1"
              >{{
                Math.ceil(
                  (userProfile.size / 1024 / userProfile.storage_data_limited) *
                    100
                )
              }}%</span
            >
            <PercentLine
              :height="9"
              :legend="false"
              :items="transformSize()"
              :text="'name'"
              :value="'size'"
              :total="userProfile.storage_data_limited"
            />
          </v-list-item-title>
        </v-list-item>
  
        <v-list-item
          @click="doLogout"
          id="navBar_userProfileDialog_logOutButton"
        >
          <v-list-item-icon>   
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
        <v-list-item style="min-height: 14px">
          <v-list-item-title style="text-align: right">
            <div class="caption">Version: {{ getVer }}</div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <Storage ref="storage" :sizes="transformSize()" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Storage from "./storage";
import PercentLine from "./percent-line";
import config from "@/config"

export default {
  name: "user-profile",
  data() {
    return {
      region: null,
      rules: {
        required: (value) => !!value || "Name is required",
        requiredRegion: (value) => !!value || "Region is required",
      },
      menuRegion: false,
      valid: false,
      menu: false,
      tab: "tab-1",
      position: "top",
      loading: false,
      notifications: [],
    };
  },
  components: {
    PercentLine,
    Storage,
  },
  computed: {
    ...mapGetters("auth", ["userProfile", "currentUserGroup"]),
    ...mapGetters("region", ["regions"]),
    getVer() {
      return config.version;
    },
    size() {
      if (this.userProfile.size < 1) {
        return {
          size: this.userProfile.size * 1024,
          unit: "kb",
        };
      } else if (
        this.userProfile.size > 1024 &&
        this.userProfile.size < 1048576
      ) {
        return {
          size: this.userProfile.size / 1024,
          unit: "Gb",
        };
      } else if (this.userProfile.size > 1048576) {
        return {
          size: this.userProfile.size / 1048576,
          unit: "T",
        };
      } else {
        return {
          size: this.userProfile.size,
          unit: "Mb",
        };
      }
    },
  },
  created() {
    // if (this.userProfile) {
    //   this.getRegion();
    // }
  },
  methods: {
    ...mapActions("auth", ["logOut"]),

    transformSize() {
      let sizes = [
        {
          name: "Image",
          size: this.userProfile.image_size
            ? this.userProfile.image_size / 1024
            : 0,
        },
        {
          name: "Result",
          size: this.userProfile.result_size
            ? this.userProfile.result_size / 1024
            : 0,
        },
        {
          name: "Model",
          size: this.userProfile.model_size
            ? this.userProfile.model_size / 1024
            : 0,
        },
        {
          name: "Vector",
          size: this.userProfile.vector_size
            ? this.userProfile.vector_size / 1024
            : 0,
        },
      ];
      return sizes;
    },
    getStorageInfo() {
      this.$refs.storage.openDialog();
    },
    doLogout() {
      this.logOut()
        .then(() => {
          this.$router.push("/login");
        })
        .catch((e) => {
          this.$router.push("/login");
        });
    },
  },
  watch: {
    menu(val) {
      if (!val) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
<style lang="css" scoped>
.info-avatar {
  width: 80px;
  height: 80px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user-profile.vue